import {globeAnimation} from './globeAnimation';
import {linearSequenceAnimation} from './linearSequenceAnimation';
import {sonarAnimation} from './sonarAnimation';
import {sonarPerspective} from './sonarPerspectiveAnimation';
import {floatingAnimation} from './floatingBoxes';

const animationSpacerEls = document.querySelectorAll('.animated-spacer svg');

animationSpacerEls.forEach((element) => {
  switch (element.dataset.element) {
  case ('animation-globe'):
    globeAnimation(element);
    break;
  case ('linear-sequence'):
    linearSequenceAnimation(element);
    break;
  case ('animation-sonar'):
    sonarAnimation(element);
    break;
  case ('animation-sonar-perspective'):
    sonarPerspective(element);
    break;
  case ('animation-floating-boxes'):
    floatingAnimation(element);
    break;
  default: break;
  }
});
